export default __webpack_public_path__ + "7c383bfb2ee0e27a845c0254d31cb4e0.svg";